/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForCostSavings extends models.GovernanceConfigurationBaseForCost {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForCostSavings");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForCostSavings.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForCostSavings>): GovernanceConfigurationForCostSavings {
        let obj = Object.assign(new GovernanceConfigurationForCostSavings(), model);
        GovernanceConfigurationForCostSavings.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForCostSavings>): GovernanceConfigurationForCostSavings {
        if (!model) return null;
        return GovernanceConfigurationForCostSavings.newInstance(<GovernanceConfigurationForCostSavings> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForCostSavings) {
        if (!obj) return;

        models.GovernanceConfigurationForCostSavings.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForCostSavings): boolean {
        if (models.GovernanceConfigurationBaseForCost.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForCostSavings.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * True if the savings cost calculation has to be done through True cost. False for legacy cost calculation.
     */
    true_cost_calculation: boolean;

}
